var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8334 7.49936C15.8334 10.721 13.2217 13.3327 10 13.3327C9.94432 13.3327 9.88877 13.3319 9.83341 13.3304V13.3327H1.16675V11.9994H6.28796C4.9924 10.9294 4.16671 9.31082 4.16671 7.49936C4.16671 4.27769 6.77838 1.66602 10 1.66602C13.2217 1.66602 15.8334 4.27769 15.8334 7.49936ZM10.0001 10.9994C11.9331 10.9994 13.5001 9.43237 13.5001 7.49937C13.5001 5.56637 11.9331 3.99936 10.0001 3.99936C8.06706 3.99936 6.50005 5.56637 6.50005 7.49937C6.50005 9.43237 8.06706 10.9994 10.0001 10.9994Z",
    fill: "#FFFFFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductWhite);
export default __webpack_public_path__ + "static/media/product-white.f95e0665dcf8e8cd67e146bee4f9b1ff.svg";
export { ForwardRef as ReactComponent };